import React, { ReactNode } from "react";

type TextTypes = {
  children?: ReactNode;
  type?: string;
  bold?: boolean;
};

const TextContainer = ({ children, type = "span", bold }: TextTypes) => {
  if (type === "span")
    return (
      <span className={`label-container ${bold ? "bold" : ""}`}>
        {children}
      </span>
    );
  return <p className="label-container">{children}</p>;
};
export default TextContainer;
